module.exports = __webpack_public_path__ + "static/media/FeaturedIn_Mobile_EN.cc34b20f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FeaturedIn_Mobile_EN.png
// module id = 577
// module chunks = 0